import React from "react";

const ShoppingCartHeader = props => {
  return (
    <div className="row status-block">
        <div className="col-md-4 item-count-msg" tabIndex="0" aria-label={"There are currently " + props.total + " items in your shopping cart."}>
            <span aria-hidden="true">
                <i className="fas fa-shopping-cart" aria-hidden="true"></i>
                <span aria-hidden="true" className="item-count">{props.total}</span>&nbsp;<span>Items in Cart</span>
                </span>
        </div>
        <div className="col-md-8 cart-status">
            <ul className="status-list">
                <li>Review Cart</li>
                <li>Billing</li>
                <li>Complete</li>
            </ul>
        </div>
    </div>
  );
};

export default ShoppingCartHeader;
